const name = 'circle-a';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M34.439 26.58L43.636 55h-5.717l-2.155-6.711h-9.777L23.833 55h-5.469l9.28-28.42h6.795zm-3.315 4.806h-.414l-1.823 7.208-1.906 5.552h7.789l-1.906-5.552-1.74-7.208z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'A',
};

export default icon;
